const templates = [
  {
    id:1,
    template: `<div class="panel-body">
                <div class="col-xs-12 col-md-6">
                    <img class="img-responsive blog-img" src="/static/images/blogs/1/Budget_Card.png" alt="">
                </div>
                <div class="col-xs-12 col-md-6" style="margin-top:40px;">
                    <span style="font-size: 17.5px;">
                        With both "at-a-glance" and detailed information, IBA's new monthly budget card eliminiates the need to constantly generate and compare multiple time-consuming reports. All the information you need is shown in one convenient, automatically updated location.
                    </span>
                </div>
            </div>
            <div class="panel-heading">
              <h3>The Three Important Pieces</h3>                                                      
            </div>
            <div class="panel-body">
                <div class="col-xs-12 col-md-6 text-left">
                    <ol class="specialli">
                        <li >Monthly Goal: The big grey bar shows your total goal. </li>
                        <li >Prorated Benchmark: Adjusts every day, it's your guide post towards reaching your goal. At the end of the month, the Prorated Benchmark and the Monthly Goal are the same.</li>
                        <li >Current Total: This is your current actual value; if the Current Total and the Prorated Benchmark are the same, you're on target.    </li>
                    </ol>
                </div>
                <div class="col-xs-12 col-md-6">
                    <img class="img-responsive blog-img" src="/static/images/blogs/1/Budget_Behind.png" alt="">
                </div>  
            </div>
            <div class="panel-heading">
              <h3>From Our Loyal Customers</h3>                                                                    
            </div>
            <div class="panel-body">
                <div class="col-xs-12 col-md-6">
                    <img class="img-responsive img-circle" src="/static/images/blogs/1/210.jpg" alt="" style="    box-shadow: -2px -1px 9px 2px #ccc9c9; margin: 0 auto;">
                </div>
                <div class="col-xs-12 col-md-6">
                    <blockquote> “This is a card I use daily that allows me to react immediately when we’re off target, correcting issues as they’re happening.  Combined with automated reporting, the owners know that I’ve got my finger on the pulse of their business.”</blockquote>
                
                    <h3>-Heather Skousen, Manager</h3>
                    <h4>Intermountain Vein Center</h4>

                </div>
            </div>
            <div class="panel-footer">

            </div>`
  },
  {
    id: 2,
    template: ` <div class="panel-body">
    <div class="col-xs-12 col-md-6">
         <img class="img-responsive blog-img" src="/static/images/blogs/2/ads-beverage-black-coffee-33972.jpg" alt="">
    </div>
    <div class="col-xs-12 col-md-6" style="margin-top:40px;">
        <div style="font-size: 17.5px;">
            Scheduled Emailing saves time and improves the accuracy of dashboards you’re already using, giving employees, owners, and stakeholders more time to focus on other tasks.
        </div>
        <hr>
        <div style="font-size: 17.5px;">
            Every email or notification can be automatically generated and sent when and where you need it. Easy to read charts, tables, and overviews can all be scheduled with just a couple of clicks.
        </div>
    </div>
</div>
<div class="panel-heading">
   <h3>Volume Milestones</h3>                                                      
</div>
<div class="panel-body">
    <div class="col-xs-12 col-md-6" style="margin-top:40px;">
        <span style="font-size: 17.5px;">
            One IBA client started reading for a new imaging center in the community.  The contract rate increased as volume went up.  Our client used IBA’s tools to automatically send weekly emails with a chart showing volume increases from one week to the next.  Both organizations used the information make sure the correct contract rates were invoiced.  And both organizations celebrated when volume milestones were reached.  The frequency in which both organizations saw the volume numbers and the simplicity of setting up the scheduled emailing was a big positive for everyone. 
        </span>
    </div>
    <div class="col-xs-12 col-md-6">
         <img class="img-responsive blog-img" src="/static/images/blogs/2/blog2.png" alt="" style="height:412px;">
    </div>  
</div>
<!-- <div class="panel-heading">
   <h3>From Our Loyal Customers</h3>                                                                    
</div>
<div class="panel-body">
    <div class="col-xs-12 col-md-6">
         <img class="img-responsive" src="/static/images/blogs/2/blog2.png" alt="" style="    box-shadow: -2px -1px 9px 2px #ccc9c9; margin: 0 auto;">
    </div>
    <div class="col-xs-12 col-md-6">
        <blockquote> “This is a card I use daily that allows me to react immediately when we’re off target, correcting issues as they’re happening.  Combined with automated reporting, the owners know that I’ve got my finger on the pulse of their business.”</blockquote>
    
        <h3>-Heather Skousen, Manager</h3>
        <h4>Intermountain Vein Center</h4>

    </div>
</div> -->
<div class="panel-footer">

</div>`
  },
  {
    id:3,
    template:`
    <div class="panel-heading">
    <h3>New and Improved Widget Interactions</h3>                                                      
    </div>
    <div class="panel-body">
 
    <div class="col-xs-12 col-md-8  col-md-offset-2">
    <span style="font-size: 17.5px;">

    Improved interactivity allows you to easily filter data from one place and see exactly what you want.
    </span>
  </div>
    <div class="col-xs-12 col-md-10 col-md-offset-1">
        <img class="img-responsive blog-img" src="/static/images/blogs/3/New_Dashboard_Interface.png" alt="">
    </div>

</div>
<div class="panel-heading" >
  <h3>Expanded Drill-Down Capabilities</h3>                                                      
</div>
<div class="panel-body">
  <div class="col-xs-12 col-md-8 col-md-offset-2">
  <span style="font-size: 17.5px;">

  Get improved flexibility with the powerful yet simplified drill-down. Set the drill-down one time and then use it anytime or anywhere you want.
  </span>
  </div>
    <div class="col-xs-12 col-md-12">
        <img class="img-responsive blog-img" src="/static/images/blogs/3/Expanded_Drill.png" alt="">
    </div>  
</div>
<div class="panel-heading">
  <h3>More Filter Levels</h3>                                                                    
</div>
<div class="panel-body">
<div class="col-xs-12 col-md-8 col-md-offset-2">
<span style="font-size: 17.5px;">  
  Filters can now be applied to all levels of data, from top to bottom. You’ll find the exact answers you’re looking for with the least amount of effort.
</span>
</div>
<div class="col-xs-12 col-md-12">
        <img class="img-responsive" src="/static/images/blogs/3/More_Filter_Levels.png" alt="" style="    box-shadow: -2px -1px 9px 2px #ccc9c9; margin: 0 auto;">
    </div>
    <div class="col-xs-12 col-md-8 col-md-offset-2">
<span style="font-size: 17.5px;">  
  Available now in select markets and will be available nationally by Late Fall 2018. 
</span>
</div>
</div>

<div class="panel-footer">

</div>`
  },
  {
    id: 4,
    template:`
          <div class="panel-body">
      
          <div class="col-xs-12 col-md-10 col-md-offset-1">
              <div class="embed-responsive embed-responsive-16by9">
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/iYrOlI-UpDU" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
          </div>
          <div class="col-md-12">
            IBA hosts Brady Giles, COO Utah Radiology Associates, on this month's webinar to discuss the power PACS, RIS and billing data has to increase revenue for physician practices, imaging centers and hospital imaging departments.  November 13, 2019.
          </div>

      </div>
     <div class="panel-footer">

      </div>
    `
  },
  {
    id: 5,
    template:`
          <div class="panel-body">
      
          <div class="col-xs-12 col-md-10 col-md-offset-1">
            <ul>
              <li>
                Data Forcasting
                <ul>
                  <li>
                    IBA enables your users to apply advanced ML-powered forecasting techniques to easily forecast future values based on historical data
                  </li>
                  <li>
                    IBA's AI engine driving the forecast uses an ensemble of various forecasting models to create the most effective forecast
                  </li>
                  <li>
                    To enable this feature please contact your <a href="mailto:info@infinittna.com">IBA Specialist</a>
                  </li>
                </ul>
              </li>
              <li>
              Share icon on your dashboard so you can see when changes you made to a dashboard aren’t visible to users you shared the dashboard with
              </li>
              <li>
                Dashboard users, including Designers and Viewers, can now choose a monthly schedule for receiving email reports
              </li>
            </ul>
          </div>
          <div class="col-md-12">
            IBA releases new dashboard features. March 1, 2020.
          </div>

      </div>
     <div class="panel-footer">

      </div>
    `
  }


]

function getTemplate(id){
  for(let i = 0; i<templates.length; i++){
    if(templates[i].id == id){      
      return templates[i].template;
    }
  }
}

export {getTemplate}


// WEBPACK FOOTER //
// ./src/js/components/blogs/posts/content.js